/* eslint-disable */
const getDefaultState = () => {
  return {
    translations: {
    },

    translationsIframe: {
    }
  }
}

const state = getDefaultState()

const getters = {
  getPeriods(state) {
    return state.periods;
  },
}

const mutations = {
  setTranslations(state, payload) {
    state.translations = payload;
  },
  setTranslationsIframe(state, payload) {
    state.translationsIframe = payload;
  }
}

const actions = {
  async loadTranslations({ commit }, url) {
    try {
      const response = await fetch(url);
      const jsText = await response.text();

      const data = extractDictionary(jsText);
      commit('setTranslations', data);
    } catch (error) {
      console.error('Dictionary download error:', error);
    }
  },

  async loadTranslationsIframe({ commit }, url) {
    try {
      const response = await fetch(url);
      const jsText = await response.text();

      const data = extractIframeDictionary(jsText);
      commit('setTranslationsIframe', data);
    } catch (error) {
      console.error('Dictionary download error:', error);
    }
  },
}

function extractDictionary(jsText) {
  const regex = /AncientDNAIllustrativeDictionary\s*=\s*(\{[\s\S]*?\});/;
  const match = jsText.match(regex);
  
  if (match && match[1]) {
    try {
      const dictString = match[1].trim(); // Nesnenin tanımını al
      
      // JSON.parse doğrudan çalışabilir çünkü örneğinizdeki sözlük geçerli JSON formatında
      const dict = JSON.parse(dictString);
      
      return dict;
    } catch (e) {
      console.error('Dictionary parse error:', e);
      return {};
    }
  }
  
  console.error('Dictionary not found.');
  return {};
}

function extractIframeDictionary(jsText) {
  const regex = /AncientDNAiFrameDictionary\s*=\s*(\{[\s\S]*?\});/;
  const match = jsText.match(regex);
  
  if (match && match[1]) {
    try {
      const dictString = match[1].trim(); // Nesnenin tanımını al
      
      // JSON.parse doğrudan çalışabilir çünkü örneğinizdeki sözlük geçerli JSON formatında
      const dict = JSON.parse(dictString);
      return dict;
    } catch (e) {
      console.error('Dictionary parse error:', e);
      return {};
    }
  }
  
  console.error('Dictionary not found.');
  return {};
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
